/**
 * 스트릭(연속 기록) 계산 유틸
 *
 * sessions 객체(키: "YYYY-MM-DD", 값: 세션 배열)에서
 * 연속 기록 일수를 계산합니다.
 *
 * 사용 시나리오:
 *   - D-1(스트릭 축하): 기록 저장 직후 → calculateCurrentStreak
 *   - D-2(스트릭 위기): 오늘 기록 없을 때 → calculateStreakAtRisk
 */

// 스트릭 축하 알림을 보내는 마일스톤 일수
export const STREAK_MILESTONES = [3, 7, 14, 30, 50, 100];

// Date 객체를 "YYYY-MM-DD" 문자열로 변환
function toDateStr(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

/**
 * 오늘을 포함한 현재 스트릭을 계산합니다.
 * 기록 저장 직후 호출용 — 오늘부터 거꾸로 연속 기록일을 셉니다.
 *
 * @param {Object} sessions - { "2026-03-23": [세션, ...], ... }
 * @returns {number} 연속 기록 일수 (오늘 기록 없으면 0)
 */
export function calculateCurrentStreak(sessions) {
  let streak = 0;
  const d = new Date();
  d.setHours(0, 0, 0, 0);

  while (true) {
    const key = toDateStr(d);
    if (sessions[key] && sessions[key].length > 0) {
      streak++;
      d.setDate(d.getDate() - 1);
    } else {
      break;
    }
  }
  return streak;
}

/**
 * 위기 스트릭을 계산합니다.
 * 오늘 기록이 없을 때, 어제부터 거꾸로 연속 기록일을 셉니다.
 * 반환값이 3 이상이면 스트릭이 위험한 상태입니다.
 *
 * @param {Object} sessions - { "2026-03-23": [세션, ...], ... }
 * @returns {number} 위기 스트릭 일수 (오늘 이미 기록했으면 0)
 */
export function calculateStreakAtRisk(sessions) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // 오늘 이미 기록했으면 위기 아님
  if (sessions[toDateStr(today)]?.length > 0) return 0;

  let streak = 0;
  const d = new Date(today);
  d.setDate(d.getDate() - 1); // 어제부터 시작

  while (true) {
    const key = toDateStr(d);
    if (sessions[key] && sessions[key].length > 0) {
      streak++;
      d.setDate(d.getDate() - 1);
    } else {
      break;
    }
  }
  return streak;
}
